import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { fromDateStampObject, toDateStampObject } from './time';
import { calendarMonthOf, monthsBetween, monthsFrom } from './time/month';
const WINDOW_MONTHS = 12;
const HORIZON_LEAD_IN_DAYS = 8;
const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;
const shiftDays = (date, days)=>toDateStampObject(new Date(date.year, date.month - 1, date.day + days));
const shiftMonths = (date, months)=>toDateStampObject(new Date(date.year, date.month - 1 + months, date.day));
const dayCountBetween = (from, to)=>Math.round((fromDateStampObject(to).getTime() - fromDateStampObject(from).getTime()) / MILLISECONDS_PER_DAY);
const roundToTwoDecimals = (value)=>Math.round(value * 100) / 100;
const monthSpanThrough = (from, lastIncluded)=>monthsBetween(from, lastIncluded) + 1;
export class BillingTimelineHorizon {
    offsetPercentOf(date) {
        return roundToTwoDecimals(dayCountBetween(this.start, date) / this.span() * 100);
    }
    anchorOffsetPercent() {
        return this.offsetPercentOf(this.anchor);
    }
    containsDate(date) {
        return dayCountBetween(date, this.end) >= 0;
    }
    billingMonths() {
        const firstMonth = calendarMonthOf(this.windowStart);
        return monthsFrom(firstMonth, monthSpanThrough(firstMonth, this.lastPlottedMonth()));
    }
    tickMonths() {
        const firstOpening = this.firstMonthOpening();
        return monthsFrom(firstOpening, monthSpanThrough(firstOpening, this.lastPlottedMonth()));
    }
    span() {
        return dayCountBetween(this.start, this.end);
    }
    lastPlottedMonth() {
        return calendarMonthOf(shiftDays(this.end, -1));
    }
    firstMonthOpening() {
        const opensOnAMonthOpening = this.start.day === 1;
        return opensOnAMonthOpening ? calendarMonthOf(this.start) : calendarMonthOf(shiftMonths(_object_spread_props(_object_spread({}, this.start), {
            day: 1
        }), 1));
    }
    constructor(windowStart, anchor){
        _define_property(this, "windowStart", void 0);
        _define_property(this, "anchor", void 0);
        _define_property(this, "start", void 0);
        _define_property(this, "end", void 0);
        this.windowStart = windowStart;
        this.anchor = anchor;
        this.start = shiftDays(windowStart, -HORIZON_LEAD_IN_DAYS);
        this.end = shiftMonths(anchor, WINDOW_MONTHS);
    }
}
